import { ModelType, SearchableRecordInstantSearch } from '@livv/models';
import { Box, Button, Grid } from '@mui/material';
import { Hit } from 'instantsearch.js';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { Configure, useInfiniteHits, useSearchBox, useInstantSearch } from 'react-instantsearch';
import CustomHit from './CustomHit';
import ScrollToTopButton from '@components/ScrollToTopButton';

const HITS_PER_PAGE = 20;

export type HitsByModelType = Partial<Record<ModelType, Hit<SearchableRecordInstantSearch>[]>>;

interface InfiniteHitsProps {
    filters: string;
    hitsPerPage?: number;
}

const InfiniteHits: FC<InfiniteHitsProps> = ({ filters, hitsPerPage = HITS_PER_PAGE }) => {
    const { t } = useTranslation('search');
    const { hits, isLastPage, showMore } = useInfiniteHits<SearchableRecordInstantSearch>();
    const { query } = useSearchBox();
    const {
        indexUiState: { configure },
    } = useInstantSearch();

    return (
        <Box sx={{ overflowAnchor: 'none' }}>
            <Configure
                // TODO: remove this component when libraries update fixes the issue. Internally types have all necessary props
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                filters={filters}
                hitsPerPage={hitsPerPage}
                facetingAfterDistinct
            />
            <Grid spacing={2} container>
                {hits.map((hit) => (
                    <Grid key={hit.objectID} xs={12} item>
                        <CustomHit filters={configure?.filters || ''} hit={hit} query={query} />
                    </Grid>
                ))}
            </Grid>
            {!isLastPage && (
                <Button onClick={showMore} sx={{ mt: 2 }} variant="contained">
                    {t('loadMore')}
                </Button>
            )}
            <ScrollToTopButton />
        </Box>
    );
};

export default InfiniteHits;
